// import config from '../configs/config'
import { drawCompressedCanvas, base64Bytes, formatSize } from './imageCompress'

class Util {
  constructor(context, props) {
    this.html = "";
  }

  limitArea() {
    const data = this.getData("MAIN_DATA");

    if (data) {
      if (data.LimitArea && data.LimitArea.length) {
        let str = "";
        data.LimitArea.forEach((item, i) => {
          str += item + " ";
        });

        return str;
      } else {
        return null;
      }
    }
  }

  // 防抖
  debounce(func, delay) {
    let timer;
    return function(...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  // 验证手机号
  isPhone(phone = "") {
    if (/^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(phone)) {
      return true;
    } else {
      return false
    }
  }

  // options: 压缩配置，同 imageCompress（quality/mimeType；默认保持原尺寸仅重编码）
  getFile(url, options = {}) {
    const opts = Object.assign(
      {
        quality: 0.8,
        mimeType: 'image/jpeg'
      },
      options
    )

    const base64ImgtoFile = (dataurl, filename = 'file') => {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    }
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.crossOrigin = 'Anonymous'
      image.src = url

      image.onload = function() {
        // 保持原尺寸，仅重新编码控制体积（修复原先非法 MIME 导致回退 PNG 变大的 bug）
        const canvas = drawCompressedCanvas(image, opts)
        const base64 = canvas.toDataURL(opts.mimeType, opts.quality)
        const file = base64ImgtoFile(base64)
        resolve(file) // 加载完成后解析结果
      }

      image.onerror = function(error) {
        reject(null)
      }
    })
  }
}
export default new Util()



// WEBPACK FOOTER //
// ./src/commons/util.js